import { termsData } from "../../tempTerms";
import NiceModal from "@ebay/nice-modal-react"
import "./style.scss"

export default function Footer ({branding}) {
    const terms = termsData

    const brandingMap = {
      "generic": "light",
      "fair-play": "light",
      "glo": "dark",
      "lucky-strike": "light",
      "pall-mall": "dark",
      "vuse": "dark"
    }

    return (
        <footer className={`footer ${brandingMap[branding]}`}>
          <ul>
            <li><button onClick={(e) => { e.preventDefault(); NiceModal.show("pdf-modal", {content: terms.impressum}) }} onKeyDown={(e) => {if(e.key === 'Enter') { e.preventDefault(); NiceModal.show("pdf-modal", {content: terms.impressum}) }}}>IMPRESSUM</button></li>
            {/* <li><button onClick={(e) => { e.preventDefault(); NiceModal.show("pdf-modal", {content: terms.teilnahmebedingungen}) }} onKeyDown={(e) => {if(e.key === 'Enter') { e.preventDefault(); NiceModal.show("pdf-modal", {content: terms.teilnahmebedingungen}) }}}>TEILNAHMEBEDINGUNGEN</button></li> */}
            {/* <li><button onClick={(e) => { e.preventDefault(); NiceModal.show("pdf-modal", {content: terms.datenschutzerklarung}) }} onKeyDown={(e) => {if(e.key === 'Enter') { e.preventDefault(); NiceModal.show("pdf-modal", {content: terms.datenschutzerklarung}) }}}>DATENSCHUTZ</button></li> */}
            {/* <li><button id="ot-sdk-btn" className="ot-sdk-show-settings">INDIVIDUELLE COOKIE-EINSTELLUNGEN</button></li> */}
          </ul>
        </footer>
    )
}